import { Application } from '../../clients/aasServerClient.generated';
import {
    ActionTypeNames,
    ApplicationsAction,
    AssignApplicationsWorkspaceAction,
    ClearSingleApplicationAction,
    CopySingleApplicationAction,
    CreateSingleApplicationAction,
    FetchAllApplicationsAction,
    FetchSingleApplicationAction,
    FetchTableApplicationsAction,
    FetchTableApplicationsNFAction,
    NewSingleApplicationAction,
    SavedSingleApplicationAction,
    SaveSingleApplicationAction,
    StoreAllApplicationsAction,
    StoreSingleApplicationAction,
    StoreTableApplicationsAction,
} from './actions';

export function fetchTableApplications(): FetchTableApplicationsAction {
    return {
        type: ActionTypeNames.FetchTableApplications
    };
}
export function fetchTableApplicationsNF(): FetchTableApplicationsNFAction {
    return {
        type: ActionTypeNames.FetchTableApplicationsNF
    };
}

export function fetchAllApplications(): FetchAllApplicationsAction {
    return {
        type: ActionTypeNames.FetchAllApplications
    };
}

export function fetchSingleApplication(id: string): FetchSingleApplicationAction {
    return {
        id,
        type: ActionTypeNames.FetchSingleApplication
    };
}
export function newSingleApplication(): NewSingleApplicationAction {
    return {
        type: ActionTypeNames.NewSingleApplication
    };
}

export function copySingleApplication(id: string): CopySingleApplicationAction {
    return {
        id,
        type: ActionTypeNames.CopySingleApplication
    };
}

export function storeSingleApplication(application: Partial<Application>): StoreSingleApplicationAction {
    return {
        application,
        type: ActionTypeNames.StoreSingleApplication,
    };
}

export function saveSingleApplication(
    application: Partial<Application>,
    serverId?: string,
    workspaceId?: string
): SaveSingleApplicationAction {
    return {
        application,
        serverId,
        type: ActionTypeNames.SaveSingleApplication,
        workspaceId,
    };
}

export function createSingleApplication(
    application: Partial<Application>,
    serverId?: string,
    workspaceId?: string
): CreateSingleApplicationAction {
    return {
        application,
        serverId,
        type: ActionTypeNames.CreateSingleApplication,
        workspaceId,
    };
}

export function clearSingleApplication(): ClearSingleApplicationAction {
    return {
        type: ActionTypeNames.ClearSingleApplication,
    };
}

export function savedSingleApplication(): SavedSingleApplicationAction {
    return {
        type: ActionTypeNames.SavedSingleApplication,
    };
}

function applicationsActionCreator<T extends ActionTypeNames>(type: T) {
    return (ids: string[]): ApplicationsAction<T> => {
        return {
            applicationIds: ids,
            type,
        };
    };
}

export function storeTableApplications(applications: Application[]): StoreTableApplicationsAction {
    return {
        applications,
        type: ActionTypeNames.StoreTableApplications,
    };
}

export function storeAllApplications(applications: Application[]): StoreAllApplicationsAction {
    return {
        applications,
        type: ActionTypeNames.StoreAllApplications,
    };
}

export const deleteApplications = applicationsActionCreator(ActionTypeNames.DeleteApplications);
export const synchronizeUsers = applicationsActionCreator(ActionTypeNames.SynchronizeUsers);

export function assignApplicationsWorkspace(
    applicationIds: string[],
    workspaceId: string
): AssignApplicationsWorkspaceAction {
    return {
        applicationIds,
        type: ActionTypeNames.AssignApplicationsWorkspace,
        workspaceId,
    };
}
